import React, { SVGProps } from 'react';

const SvgLinkColorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <mask id="LinkColorIcon_svg__a" width={40} height={40} x={-8} y={-8} maskUnits="userSpaceOnUse">
      <path fill="#fff" d="M-8-8h40v40H-8z" />
      <path fill="#000" d="M3.8 6.1h7.5a5.9 5.9 0 0 1 0 11.8H3.8a5.9 5.9 0 0 1 0-11.8Z" />
    </mask>
    <mask id="LinkColorIcon_svg__b" width={40} height={40} x={-8} y={-8} maskUnits="userSpaceOnUse">
      <path fill="#fff" d="M-8-8h40v40H-8z" />
      <path
        fill="#000"
        d="M6.8 12a5.9 5.9 0 0 1 5.9-5.9h7.5a5.9 5.9 0 0 1 5.9 5.9h-4.8a1.1 1.1 0 0 0-1.1-1.1h-7.5a1.1 1.1 0 0 0-1.1 1.1Z"
      />
    </mask>
    <path
      fill="#3374BA"
      fillRule="evenodd"
      d="M12.7 7.3h7.5a4.7 4.7 0 0 1 0 9.4h-7.5a4.7 4.7 0 0 1 0-9.4Zm0 2.4h7.5a2.3 2.3 0 0 1 0 4.6h-7.5a2.3 2.3 0 0 1 0-4.6Z"
      clipRule="evenodd"
      mask="url(#LinkColorIcon_svg__a)"
      transform="rotate(-45 12 12)"
    />
    <path
      fill="#57A0D7"
      fillRule="evenodd"
      d="M3.8 7.3h7.5a4.7 4.7 0 0 1 0 9.4H3.8a4.7 4.7 0 0 1 0-9.4Zm0 2.4h7.5a2.3 2.3 0 0 1 0 4.6H3.8a2.3 2.3 0 0 1 0-4.6Z"
      clipRule="evenodd"
      mask="url(#LinkColorIcon_svg__b)"
      transform="rotate(-45 12 12)"
    />
    <path
      fill="#3374BA"
      d="M9.172 14.828a4.7 4.7 0 0 1 0-6.646l5.303-5.304a4.7 4.7 0 0 1 6.647 0l-1.697 1.697a2.3 2.3 0 0 0-3.253 0L10.869 9.88a2.3 2.3 0 0 0 0 3.252Z"
    />
  </svg>
);
SvgLinkColorIcon.defaultProps = {
  width: '24',
  height: '24',
  color: 'currentColor',
};
export default SvgLinkColorIcon;
